import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule, Http  } from '@angular/http';
import { TranslateModule , TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Router } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular/main';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardModule } from './dashboard/dashboard.module';
import { HeaderComponent } from './shared/header/header.component';
import { SharedService } from './shared/shared.service';
import { NetworkingService } from './shared/networking.service';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { NgxInactivity } from 'ngx-inactivity';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { CreateAgencyModule } from './create-agency/create-agency.module';
// import { LoginComponent } from './login/login.component';
// import { LoginService } from './login/login.service';
import { NavigationMenuComponent } from './shared/navigation-menu/navigation-menu.component';
import { LoaderComponent } from './shared/loader/loader.component';
import { LoaderService } from './shared/loader/loader.service';
import { ReportsModule } from './reports/reports.module';
import { StorageServiceModule} from 'angular-webstorage-service';
import { SharedModule } from './shared/shared.module';
import { NotFoundComponent } from './not-found/not-found.component';
import { EnvironmentComponent } from './environment.component';
import { ExternalService } from './shared/external.service';


export function HttpLoaderFactory(http: Http) {
    return new TranslateHttpLoader(http, "assets/data/i18n/", ".json");
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    // LoginComponent,
    NavigationMenuComponent,
    LoaderComponent,
    NotFoundComponent,
    EnvironmentComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AppRoutingModule,
    DashboardModule,
    CreateAgencyModule,
    SharedModule,
    ReportsModule,
    HttpModule,
    NgxInactivity,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [Http]
      }
    }),    
    CollapseModule,
    AgGridModule.withComponents([]),
    BsDropdownModule.forRoot(),
    AccordionModule.forRoot(),
    StorageServiceModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule
  ],
  exports:[NavigationMenuComponent, LoaderComponent],
  providers: [
    SharedService, 
    NetworkingService, 
    //LoginService,
    LoaderService,
    ExternalService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/app.module.ts